export const post_initiate_contract = "payments/order/initiate_contract";
export const refresh_contract = "payments/order/refresh_contract";
export const get_redirect_url_polling_api = "payments/order/kyc/poll";
